import Stack from '@mui/material/Stack';

import SelectionTabs from '@webclient/components/search-forms/gamification-search/actions/filters/components/selection-tabs';
import AutoplayInSettings from '@webclient/components/settings/components/tabs/voice/components/autoplay';

import PlayCircleRoundedIcon from '~icons/knowz-iconify/play-circle-rounded';

import { useTranslate } from '@tolgee/react';

export default function Autoplay() {
  const { t } = useTranslate();

  return (
    <Stack>
      <SelectionTabs
        direction="row"
        sx={{
          alignItems: 'center',
        }}
        title={t(
          'layout.main.sections.header.settings.voice.autoPlay.title',
          'Auto Play',
        )}
        Icon={<PlayCircleRoundedIcon />}
        subtitle={t(
          'layout.main.sections.header.settings.voice.autoPlay.subtitle',
          'Automatically play the audio response.',
        )}
      >
        <AutoplayInSettings />
      </SelectionTabs>
    </Stack>
  );
}
